"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminRewardsFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var AdminRewardsFactory = /** @class */ (function (_super) {
    __extends(AdminRewardsFactory, _super);
    function AdminRewardsFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    AdminRewardsFactory.prototype.deploy = function (_arcDAO, _rewardsToken, overrides) {
        return _super.prototype.deploy.call(this, _arcDAO, _rewardsToken, overrides || {});
    };
    AdminRewardsFactory.prototype.getDeployTransaction = function (_arcDAO, _rewardsToken, overrides) {
        return _super.prototype.getDeployTransaction.call(this, _arcDAO, _rewardsToken, overrides || {});
    };
    AdminRewardsFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    AdminRewardsFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    AdminRewardsFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return AdminRewardsFactory;
}(contracts_1.ContractFactory));
exports.AdminRewardsFactory = AdminRewardsFactory;
var _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_arcDAO",
                type: "address",
            },
            {
                internalType: "address",
                name: "_rewardsToken",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bool",
                name: "_status",
                type: "bool",
            },
        ],
        name: "ClaimableStatusUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "reward",
                type: "uint256",
            },
        ],
        name: "RewardPaid",
        type: "event",
    },
    {
        inputs: [],
        name: "arcDAO",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "earned",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "exit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "getReward",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "getRewardForDuration",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "getTotalBalance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "getUserBalance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "lastTimeRewardApplicable",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lastUpdateTime",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "periodFinish",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "rewardPerToken",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "rewardPerTokenStored",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "rewardRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "rewardsDuration",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "rewardsToken",
        outputs: [
            {
                internalType: "contract IERC20",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "users",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "amounts",
                type: "uint256[]",
            },
        ],
        name: "setRewards",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bool",
                name: "_enabled",
                type: "bool",
            },
        ],
        name: "setTokensClaimable",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "stake",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "tokensClaimable",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "withdraw",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "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";
